import React from 'react';
import { ErrorResult } from '../components/ErrorResult.component'

export const NotFound = () => {
  const error = {
    status: 404,
    data: {
      message: 'Page Not Found',
    },
  }
  return <ErrorResult error={error} />
}
